import qs from "query-string";
import dayjs from "dayjs";

export const parseSearch = (search: string) => {
  return qs.parse(search);
};

export const getDate = () => {
  return dayjs().format("YYYY年MM月DD日 HH:mm");
};
